/* AaryOM motion layer */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('aar-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });

  function prep(el, delay) {
    if (!el || el.classList.contains('aar-reveal')) return;
    if (delay) el.style.setProperty('--aar-d', delay + 'ms');
    el.classList.add('aar-reveal');
    io.observe(el);
  }

  function init() {
    var sections = document.querySelectorAll('#MainContent .shopify-section');
    sections.forEach(function (s, i) { if (i > 0) prep(s, 0); });

    document.querySelectorAll('.resource-list__item').forEach(function (el) {
      var idx = Array.prototype.indexOf.call(el.parentElement.children, el);
      prep(el, Math.min(idx * 80, 480));
    });

    document.querySelectorAll('.media-with-content__content .group-block-content > *').forEach(function (el, i) {
      prep(el, Math.min(i * 110, 440));
    });
  }

  /* Header shadow toggle */
  function watchTop() {
    var update = function () {
      if (window.scrollY < 8) { document.body.setAttribute('data-at-top', ''); }
      else { document.body.removeAttribute('data-at-top'); }
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); watchTop(); });
  } else { init(); watchTop(); }
})();
